import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import {
  fetchGetBusinessUserOnly,
  fetchDashboardInvoices,
  resetDashboardInvoices,
  downloadTicketFile,
  fetchLogout
} from 'alelo-logic/actions'
import AddItem from '../../modules/AddItem'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'
import InvoicesList from '../../modules/InvoicesList'
import { setLoading } from '../../modules/PageLoader/actions'
import imageConfirmation from '../../../static/confirmation.png'
import pfErrorImage from '../../../static/traffic-signal-error.svg'

import { gqlMutate } from '../../../alelo-logic/services/common/apolloClient'
import { gqlSolicitarBoleto } from '../../../alelo-logic/services/queries/invoices'

import { Heading, Paragraph, BoxHeader, Content } from './styles'

import {
  helmetTitle,
  invoiceTitle,
  invoiceDescription,
  noInvoiceTitle,
  noInvoiceDescription,
  boletoModalTitle,
  boletoModalBody,
  boletoUnavailableModalTitle,
  boletoUnavailableModalBody
} from './data.json'

class DashboardInvoice extends Component {
  state = {
    loadingMore: false
  }

  async componentDidMount() {
    this.props.setLoading(true)
    await this.props.getUserData()
    await this.props.resetInvoices()
    this.fetchInvoices()
  }

  fetchInvoices = nextUrl => {
    this.setState(() => ({
      loadingMore: true
    }))
    const params = this.props.match.params || {}
    this.props
      .fetchInvoices(params.id, nextUrl)
      .then()
      .catch()
      .finally(() => {
        this.setState(() => ({
          loadingMore: false
        }))
      })
  }

  handleRequestNewBoleto = async (planId, invoiceId) => {
    const { showRequestNewBoletoResponseModal, showErrorModal } = this.props
    const { data } = await gqlMutate(gqlSolicitarBoleto, {
      idConta: planId,
      nsu: invoiceId
    })

    if (data && data.solicitarBoleto && data.solicitarBoleto.codigo === '200') {
      return showRequestNewBoletoResponseModal()
    } else if (data.solicitarBoleto.mensagem === 'Já existe uma solicitação para o boleto') {
      return showErrorModal(boletoUnavailableModalBody)
    } else {
      return showErrorModal()
    }
  }

  render() {
    const { invoices, downloadCSVInvoice } = this.props
    const { loadingMore } = this.state

    const params = this.props.match.params || {}
    return (
      <section>
        <Helmet title={helmetTitle} />
        {!invoices || invoices.data.length === 0 ? (
          <Content>
            <BoxHeader>
              <Heading>{noInvoiceTitle}</Heading>
              <Paragraph>{noInvoiceDescription}</Paragraph>
            </BoxHeader>
          </Content>
        ) : (
          <Content>
            <BoxHeader>
              <Heading>
                {(this.props.account || {}).pc ? 'Faturas e Repasses' : invoiceTitle}
              </Heading>
              <Paragraph>{(this.props.account || {}).pc ? '' : invoiceDescription}</Paragraph>
            </BoxHeader>
            <AddItem
              data={invoices.data}
              next={invoices.next.proxima}
              planId={params.id}
              fetchHandler={this.fetchInvoices}
            >
              <InvoicesList
                downloadTicket={downloadCSVInvoice}
                loadingMore={loadingMore}
                requestNewBoleto={this.handleRequestNewBoleto}
              />
            </AddItem>
          </Content>
        )}
      </section>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  invoices: reducer.dashboardInvoices,
  account: reducer.account
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchInvoices: (planId, nextURL) =>
    dispatch(fetchDashboardInvoices(planId, nextURL))
      .then(() => dispatch(setLoading(false)))
      .catch(resp => {
        if (resp && (resp.status === 401 || resp.status === 403)) {
          dispatch(fetchLogout())
          ownProps.history.push('/conta/login')
        }
      }),
  showRequestNewBoletoResponseModal: () => {
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: boletoModalTitle,
        modalDescription: boletoModalBody,
        image: imageConfirmation
      })
    )
  },
  showErrorModal: (description = '') =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: 'Ops! Algo deu errado',
        modalDescription: description ? (
          <span>{description}</span>
        ) : (
          <span>Erro ao solicitar geração de boleto.</span>
        ),
        accountType: 'pf',
        image: pfErrorImage
      })
    ),
  resetInvoices: () => dispatch(resetDashboardInvoices()),
  downloadCSVInvoice: (planId, invoiceId) => {
    dispatch(setLoading(true))
    dispatch(downloadTicketFile(planId, invoiceId))
      .then(response => {
        response.arrayBuffer().then(buffer => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([buffer]), 'Boleto.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([buffer]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Boleto.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
      })
      .catch(err => {
        return err.json()
      })
      .then(message => {
        if (message.statusCode === '20' || message.statusName === 'NAO_DISPONIVEL_SOLICITANDO') {
          dispatch(
            showModal(CONFIRM_UPDATE, {
              modalTitle: boletoModalTitle,
              modalDescription: boletoModalBody,
              image: imageConfirmation
            })
          )
        } else if (
          message.statusCode === '21' ||
          message.statusName === 'NAO_DISPONIVEL_SOLICITADO_PREVIAMENTE'
        ) {
          dispatch(
            showModal(CONFIRM_UPDATE, {
              modalTitle: boletoUnavailableModalTitle,
              modalDescription: boletoUnavailableModalBody,
              image: imageConfirmation
            })
          )
        }
      })
      .finally(() => dispatch(setLoading(false)))
  },
  getUserData: () => dispatch(fetchGetBusinessUserOnly()),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardInvoice)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardInvoice/index.js